// @ts-expect-error i18n
import i18nResourcesPrompt from '@alienfast/i18next-loader?include=**/reg_path/signup_to_download/survey/BaseQuestion.json!config/locales_i18next/index.js';
import styled from 'astroturf/react';
import addResources from 'js/i18next/addResources';
import { useTranslationTest } from 'js/utils/hooks';
import { Fragment, useEffect } from 'react';
import { SurveyQuestion, SurveyQuestionPrompt } from './styles/QuestionStyles';
import { QuestionType, UserTaggingQuestion } from './types';
import _FreeformInput from "FreeformQuestion-FreeformInput.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/user_tagging/FreeformQuestion.tsx?styleId=FreeformInput";
import _Subprompt from "FreeformQuestion-Subprompt.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/user_tagging/FreeformQuestion.tsx?styleId=Subprompt";
import _AnswersContainer from "FreeformQuestion-AnswersContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/user_tagging/FreeformQuestion.tsx?styleId=AnswersContainer";


const PROMPT_TRANSLATION_NAMESPACE = 'RegPath.SignupToDownload.BaseQuestion';
addResources(i18nResourcesPrompt, PROMPT_TRANSLATION_NAMESPACE);

interface Props {
  question: UserTaggingQuestion & { questionType: QuestionType.Freeform };
  setQuestionLoadTime: () => void;
  maxAnswers?: number;
  answers: string[];
  updateAnswer(i: number, answer: string): void;
  numbered?: boolean;
  dynamic?: boolean;
}

const FreeformInput = /*#__PURE__*/styled("input", null, {
  displayName: "FreeformInput",
  styles: _FreeformInput
});

const Subprompt = /*#__PURE__*/styled("div", null, {
  displayName: "Subprompt",
  styles: _Subprompt
});

const AnswersContainer = /*#__PURE__*/styled("div", null, {
  displayName: "AnswersContainer",
  styles: _AnswersContainer
});

const FreeformQuestion: React.FC<Props> = ({
  question,
  setQuestionLoadTime,
  answers,
  updateAnswer,
  numbered = false,
  dynamic = false,
}) => {
  const { prompt, subprompt } = question;
  const [tPrompt] = useTranslationTest(PROMPT_TRANSLATION_NAMESPACE, true);
  useEffect(setQuestionLoadTime, [setQuestionLoadTime]);
  return (
    <SurveyQuestion>
      <SurveyQuestionPrompt>{tPrompt(prompt)}</SurveyQuestionPrompt>
      {subprompt && <Subprompt>{tPrompt(subprompt)}</Subprompt>}
      <AnswersContainer labeled={numbered}>
        {answers.map((a, i) => (
          <Fragment key={i}>
            {numbered && <div>{i + 1}.</div>}
            {(!dynamic ||
              (dynamic && (i === 0 || answers[i - 1]?.length > 0))) && (
              <FreeformInput
                value={a}
                placeholder={
                  dynamic && i > 0
                    ? tPrompt('optionalAnotherTopic')
                    : tPrompt('specificTopic')
                }
                onChange={(event) => {
                  updateAnswer(i, event.target.value);
                }}
              />
            )}
          </Fragment>
        ))}
      </AnswersContainer>
    </SurveyQuestion>
  );
};

export default FreeformQuestion;
